import Vue from 'vue';
import Vuex from 'vuex';

import quote from './modules/quote';
import invite from './modules/invite';
import success from './modules/success';
import nav from './modules/nav';
import modal from './modules/modal';
import transactions from './modules/transactions';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        'quote': quote,
        'invite': invite,
        'success': success,
        'nav': nav,
        'modal': modal,
        'transactions': transactions,
    },
    strict: true
})